import { bookingLabel, routes } from "../../data/site";
import { cx } from "../../lib/cx";
import { localHref } from "../../lib/links";

const base =
  "inline-flex items-center justify-center gap-2 rounded-brand font-bold whitespace-nowrap transition duration-150 hover:-translate-y-px motion-reduce:hover:translate-y-0";

const variants = {
  /** Golden Sun with slate text: the main call to action everywhere. */
  primary: "bg-yellow text-slate hover:shadow-glow",
  /** White outline for the blueprint and other dark grounds. */
  glass:
    "border-2 border-white/35 text-white hover:border-yellow hover:text-yellow",
  /** Slate outline for light sections. */
  outline:
    "border-2 border-slate/25 text-slate hover:border-blue hover:text-blue-deep",
  /** Solid graphite for yellow sections. */
  dark: "bg-ink text-white hover:bg-ink-2",
};

const sizes = {
  lg: "px-[26px] py-[13px] text-base",
  md: "px-5 py-2.5 text-[15px]",
};

const classes = (variant, size, className) =>
  cx(base, variants[variant], sizes[size], className);

/** Brand button link. With no href it books a meeting. */
export function ButtonLink({
  href = routes.booking,
  variant = "primary",
  size = "lg",
  className,
  children = bookingLabel,
  ...props
}) {
  return (
    <a
      className={classes(variant, size, className)}
      href={localHref(href)}
      {...props}
    >
      {children}
    </a>
  );
}

/** Brand button for in-page actions. */
export function Button({
  variant = "primary",
  size = "lg",
  type = "button",
  className,
  children,
  ...props
}) {
  return (
    <button
      type={type}
      className={classes(variant, size, className)}
      {...props}
    >
      {children}
    </button>
  );
}
